import { Route, Redirect } from "react-router-dom";
import userContext from "../contexts/userContext";
import React, { useContext } from "react";
import Creation from "../example-pages/Creation";

const PrivateRoutesEdit = () => {
  const { role, setRole } = useContext(userContext);

  return role.user &&
    [
      "Chargeur Principal",
      "Sous Compte Chargeur",
      "Chargeur Secondaire",
      "Vérificateur",
      "Validateur",
      "Vérificateur Regule",
      "Validateur Regule",
      "Validateur Transit",
      "Administrateur",
      "Modificateur",
      "Operation",
    ].includes(role.user.roles[0].name) ? (
    <Route path="/Edit/:id/:mode/:sens?" component={Creation} />
  ) : (
    <Redirect to="/PagesError404" />
  );
};

export default PrivateRoutesEdit;
